module.exports = __webpack_public_path__ + "static/media/image76.82b72708.png";